import { collectionServiceClient } from "@/api/collectionServiceClient";
import { SaveRiskReportReq } from "@/pbjs/xcommon/collection_pb";
import { setCommon, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
enum CollectionType {
  CollectionTypeNone = 0,
  CollectionTypeRemind = 1,
  CollectionTypeUrge = 2
}
interface Options {
  CaseId: number; // 案件ID
  OrderId: string; // 订单ID [jstype = JS_STRING];
  ItemId: number; // 工单分类
  UrgeType: CollectionType; // 案件类型
  PhoneConnected: number; // 是否接通
  PhoneObject: number; // 拨打对象
  // PhoneCallInput: string; // 拨打对象手机号
  RiskReport: string; // 风险上报
  PhoneTime: string; // 拨打时间
}
export function saveRiskReport(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new SaveRiskReportReq();
      request.setCommonin(setCommon());
      request.setCaseid(arg.CaseId); // 工单分类
      request.setUrgetype(arg.UrgeType); // 工单分类
      request.setOrderid(arg.OrderId); // 工单分类
      request.setItemid(arg.ItemId); // 工单分类
      request.setPhoneconnected(arg.PhoneConnected); // 工单分类
      request.setPhoneobject(arg.PhoneObject); // 工单分类
      request.setPhonecallinput(null); // 拨打对象电话号码
      request.setPhonetime(arg.PhoneTime); // 工单分类
      request.setRiskreport(arg.RiskReport); // 工单分类
      let _res = await collectionServiceClient.saveRiskReport(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      return handleResponse(response, null);
      // return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
